<template lang="pug">
  v-app
    navigation
    v-main.pa-0
      homeSection
      runningLine
      specialistTeamSection(v-if='teams.length>0' :specialistTeams="teams"  @onBooking="booking")
      startWorkSection
      registrationApplicationSection(:specialistTeam="specialistTeam")
    footerSection
    cookieMessage(v-if="!isShowCookieMessage")

</template>

<script>
import axios from 'axios'
import cookies from 'vue-cookie'
import navigation from './components/ui/Navigation'
import homeSection from './components/HomeSection'
import runningLine from './components/ui/RunningLine'
import specialistTeamSection from './components/SpecialistTeamSection'
import startWorkSection from './components/StartWorkSection'
import registrationApplicationSection from './components/RegistrationApplicationSection'
import footerSection from './components/ui/Footer'
import cookieMessage from './components/ui/CookieMessage'

export default {
  name: 'App',
  components: {
    navigation,
    homeSection,
    runningLine,
    specialistTeamSection,
    startWorkSection,
    registrationApplicationSection,
    footerSection,
    cookieMessage,
  },
  data () {
    return {
      cookies,
      latestProducts: [],
      specialistTeam: null,
      teams: [],
    }
  },
  computed: {
    isShowCookieMessage () {
      return !!this.cookies.get('cookieconsent_status')
    }
  },
  created () {
    this.getSpecialistTeams()
  },
  methods: {
    booking (item) {
      this.specialistTeam = item
      setTimeout(() => this.specialistTeam = null, 1000)
    },
    getSpecialistTeams() {
      axios
        .get('/api/specialist-teams/')
        .then(response => {
          this.teams = response.data
        })
        .catch(error => {
          console.log( 'error')
        })
    }
  }
};
</script>

<style lang="sass">
  @import "components/ui/scss/variables.scss"
  @import "components/ui/scss/colors.scss"

  @font-face
    font-family: "GothamProMedium"
    src: local("GothamProMedium"), url(~@/assets/fonts/GothamPro/gothampro_medium.ttf) format("truetype")

  @font-face
    font-family: "GothamProClassic"
    src: local("GothamProClassic"), url(~@/assets/fonts/GothamPro/gothampro.ttf) format("truetype")

  @font-face
    font-family: "GothamProblack"
    src: local("GothamProblack"), url(~@/assets/fonts/GothamPro/gothampro_black.ttf) format("truetype")

  @font-face
    font-family: "RobotoRegular"
    src: local("RobotoRegular"), url(~@/assets/fonts/Roboto/RobotoRegular.ttf) format("truetype")

  @media (min-width: $xxxl)
    .frontText
      font-size: 50px !important

  @media(max-width: $smAndDown)
    .frontText
      font-size: calc(20px + 1vw) !important

  .title-style
    margin-top: 5%
    margin-bottom: 120px
    margin-left: $marginMaxL
    display: flex
    max-width: 1500px


  .backText
    position: absolute
    max-width: $maxWidthContent
    max-height: 99px

    font-style: normal
    font-weight: 700
    line-height: 120%
    letter-spacing: 0.01em
    color: #CBE4F8
    font-family: GothamProMedium
    -webkit-touch-callout: none
    -webkit-user-select: none
    -moz-user-select: none
    -ms-user-select: none
    user-select: none
    font-size: min(calc(1px + 5vw), 100px)

  .frontText
    position: absolute
    z-index: 1
    max-width: 950px
    max-height: 54px

    font-style: normal
    font-weight: 450
    line-height: 120%
    letter-spacing: 0.01em
    color: $black
    font-size: calc(27px + 1vw)
    font-family: GothamProMedium

  .section-param
    min-width: 340px

  .section-color
    background-color: $backgroundContainer

</style>